import React, { FC } from "react";
import { UsersSearchHeaderWrapper } from "./UsersSearchHeader.style";
import {
  InformationBox,
  MuiButtonPrimary,
  MuiGrid,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { searchUsersSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import PermissionWrapper from "../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../helpers/constants";

interface UsersSearchHeaderProps {
  pageId: string;
  onAddUser: () => void;
}

export const UsersSearchHeader: FC<UsersSearchHeaderProps> = ({
  pageId,
  onAddUser,
}) => {
  const { pageTitle, fetchLabel } = useSiteCore();

  return (
    <UsersSearchHeaderWrapper>
      <MuiGrid container>
        <MuiGrid size={{ sm: 6, xs: 12 }} className="header-left">
          <InformationBox title={pageTitle} />
        </MuiGrid>
        <PermissionWrapper permission={MODULE_PERMISSIONS.CREATE_USERS}>
          <MuiGrid size={{ sm: 6, xs: 12 }} className="header-right">
            <MuiButtonPrimary
              onClick={onAddUser}
              className="header-right-button"
              id={`${pageId}-new-button`}
              data-testid={`${pageId}-new-button`}
            >
              {fetchLabel(
                searchUsersSiteCoreKeys.usersHeader,
                searchUsersSiteCoreKeys.addUserButton,
              )}
            </MuiButtonPrimary>
          </MuiGrid>
        </PermissionWrapper>
      </MuiGrid>
    </UsersSearchHeaderWrapper>
  );
};
